module.exports = __webpack_public_path__ + "assets/img/0icon.6d22494a.png";